import { AfterSalesView, AfterSalesClientProfileView } from "../../Views/Home";

export const AfterSalesRoutes = [
  {
    path: "/view",
    name: "AfterSalesView:after-sales",
    component: AfterSalesView,
    layout: "/home/after-sales",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
  {
    path: "/client-profile",
    name: "AfterSalesClientProfileView:client-profile",
    component: AfterSalesClientProfileView,
    layout: "/home/after-sales",
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [],
  },
];
